/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Cross_ReferenceInputs */

const en_reading_class_cross_reference = /** @type {(inputs: Reading_Class_Cross_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pointers to figures and sections`)
};

const es_reading_class_cross_reference = /** @type {(inputs: Reading_Class_Cross_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remisiones a figuras y secciones`)
};

/**
* | output |
* | --- |
* | "Pointers to figures and sections" |
*
* @param {Reading_Class_Cross_ReferenceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_cross_reference = /** @type {((inputs?: Reading_Class_Cross_ReferenceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Cross_ReferenceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_cross_reference(inputs)
	return en_reading_class_cross_reference(inputs)
});